define('PartLookup.PartList.View', [
  'SCView',
  'PartLookup.Hotspots.View',
  'partlookup_modelinfo.tpl',
  'underscore'
], function (
  SCViewModule,
  PartLookupHotspotsView,
  partlookup_modelinfo_tpl,
  _
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function PartLookupPartListView (options) {
    SCView.call(this, options);
    
    this.application = options.application;
    this.template = partlookup_modelinfo_tpl;
    
    this.model = options.model;
    debugger;
    this.model.on('request', this.setLoading, this);
    this.model.on('sync', this.unsetLoading, this);
    //debugger;
    this.application.getLayout().on('afterAppendView', this.initHotspots, this);
  }

  PartLookupPartListView.prototype = Object.create(SCView.prototype);

  _.extend(PartLookupPartListView.prototype, {

    constructor: PartLookupPartListView,

    setLoading: function() {
      this.isLoading = true;
      this.render();
    },
    
    unsetLoading: function() {
      this.isLoading = false;
      this.render();
    },

    getChildViews: function() {
      var self = this;

      return {
        'PartLookup.Hotspots.View': function() {
          return new PartLookupHotspotsView({
            application: self.application,
            model: self.model
          });
        }
      };

    },

    initHotspots: function() {

      var self = this;
      var assemblyData = this.getCurrentAssemblyData();
      var hotspotCoords = [];
      var img = new Image();
      
      img.src = assemblyData && assemblyData.ImageUrl;

      img.onload = function() {

        _.each(assemblyData.hotspots, function(hotspot) {

          var item = _.findWhere(assemblyData.assemblyItems, {
            Tag: hotspot.Tag
          });

          if ( !item ) {
            return;
          }

          hotspotCoords.push( self.mapHotspotCoords(item, img.naturalWidth, img.naturalHeight, hotspot) );

        });

        self.model.set('hotspots', hotspotCoords);
      };

    },

    mapHotspotCoords: function(item, imgWidth, imgHeight, hotspot) {

      var avgX = (hotspot.BottomRight.X + hotspot.TopLeft.X) / 2;
      var avgY = (hotspot.BottomRight.Y + hotspot.TopLeft.Y) / 2;

      var hotspotItem = _.clone(item, {});
      hotspotItem.xPosition = (avgX / imgWidth) * 100;
      hotspotItem.yPosition = (avgY / imgHeight) * 100;

      return hotspotItem;
    },

    getCurrentAssemblyData: function() {
      var self = this;

      var currentModelAssembly = _.find(this.model.get('modelAssemblies'), {
        Id: Number( self.model.get('selectedAssemblyId') )
      });

      return _.extend(currentModelAssembly, this.model.get('selectedAssembly') );
    },

    getContext: function() {

      var assemblyData = this.getCurrentAssemblyData();
      debugger;
			return {
        brandName: !!this.model.get('brandData') && !!this.model.get('brandData').brandName ? this.model.get('brandData').brandName : '',
        isLoading: this.isLoading,
        hasModelSearchInput: !!this.model.get('modelSearchInput'),
        hasAssemblyItems: !!assemblyData && !!assemblyData.assemblyItems?.length,
				modelName: this.model.get('modelName') || '',
				selectedAssembly: assemblyData || {},
				modelAssemblies: this.model.get('modelAssemblies') || [],
        isEnvironmentBrowser: SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled,
			};
    }

  });

  return PartLookupPartListView
});
